// removed by extract-text-webpack-plugin
module.exports = {"Button":"_2vDno","Bar":"_2NUlq","Bar__1":"_3rCAa","Bar__2":"_1REQb","Bar__3":"_RMlxf","BarLight":"_22Y0z","BarDark":"_3Bsba"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/NavigationToggle/NavigationToggle.scss
// module id = 663
// module chunks = 0